module.exports = __webpack_public_path__ + "img/early-and-late-summer.1edacb91.png";